export const APP_BREADCRUMBS_CONTAINER_ID = 'app-breadcrumbs-container';

export const MIN_BREADCRUMBS_WIDTH = 80;
